module.exports = __webpack_public_path__ + "img/tt-0.c9145370.png";